<template>
  <v-container fluid class="repCostCenterContainer">
    <v-layout row wrap>
      <v-flex xs12>
        <data-card color="primary" :title="$tc(this.viewMode === '2' ? 'report.singleEntries.titleOfOneProject' : 'report.singleEntries.title' , 2)">
          <template slot="title-items">
            <v-menu offset-y bottom left nudge-bottom="5" transition="slide-y-transition">
              <template v-slot:activator="{ on }">
                <v-btn icon small color="secondary" v-on="on">
                  <v-icon color="white">more_vert</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-tile v-if="isUserAdministrator" :href="exportAcrossFacilitiesUrl" target="_blank" >
                  <v-list-tile-title>{{ $t('report.singleEntries.generalFacilitiesExport') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile :href="exportUrl" target="_blank" >
                  <v-list-tile-title>{{ $t('report.singleEntries.export') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile :to="balancesOfCostCentersUrl" v-if="this.viewMode !== '2'" >
                  <v-list-tile-title>{{ $t('report.singleEntries.balancesOfCostCenters') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile :to="balancesOfProjectsUrl" v-if="this.viewMode !== '2'" >
                  <v-list-tile-title>{{ $t('report.singleEntries.balancesOfProjects') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile :href="exportProjectAdminsUrl" target="_blank" v-if="this.viewMode === '2' && isUserAdministrator" >
                  <v-list-tile-title>{{ $t('report.singleEntries.exportProjectAdmins') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile :to="resetSingleEntriesUrl" v-if="this.viewMode === '2'" >
                  <v-list-tile-title>{{ $t('report.singleEntries.resetSingleEntriesView') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
          <template slot="controls">
                <v-flex xs12>
                  <v-layout row>
                    <v-flex xs3>
                      <v-autocomplete
                        hide-details
                        prepend-inner-icon="filter_list"
                        v-model="selectedYear"
                        :items="years"
                        :label="$tc('common.year', 1)"
                        :placeholder="$tc('common.year', 1)"
                        dark
                        solo-inverted
                        flat
                        class="small">
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs3 lg2>
                      <v-autocomplete
                        hide-details
                        prepend-inner-icon="filter_list"
                        v-model="selectedPeriodAt"
                        :items="bookingPeriods"
                        :label="$t('report.singleEntries.periodAt')"
                        :placeholder="$t('report.singleEntries.periodAt')"
                        dark
                        solo-inverted
                        flat
                        class="small">
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs3 lg2>
                      <v-autocomplete
                        hide-details
                        prepend-inner-icon="filter_list"
                        v-model="selectedPeriodTo"
                        :items="bookingPeriods"
                        :label="$t('report.singleEntries.periodTo')"
                        :placeholder="$t('report.singleEntries.periodTo')"
                        dark
                        solo-inverted
                        flat
                        class="small">
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs3 lg5>
                      <v-autocomplete v-if="this.viewMode !== '2'"
                        hide-details
                        prepend-inner-icon="filter_list"
                        v-model="selectedFacilityId"
                        :items="facilityList"
                        item-text="displayName"
                        item-value="id"
                        :label="$tc('common.facility', 1)"
                        :placeholder="$tc('common.facility', 1)"
                        :loading="isLoadingFacilities"
                        dark
                        solo-inverted
                        flat
                        class="small">
                        </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row>
                    <v-flex xs3>
                      <v-text-field
                        :label="$tc('common.costCenter', 1)"
                        clearable
                        hide-details
                        dark
                        solo-inverted
                        flat
                        :class="['small']"
                        :value="costCenterFilter"
                        @change="costCenterFilter = $event"
                        @click:clear="costCenterFilter = null"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        :label="$tc('common.generalLedgerAccount', 1)"
                        clearable
                        hide-details
                        dark
                        solo-inverted
                        flat
                        :class="['small']"
                        :value="generalLedgerAccountFilter"
                        @change="generalLedgerAccountFilter = $event"
                        @click:clear="generalLedgerAccountFilter = null"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        :label="$tc('common.project', 1)"
                        :clearable = "this.viewMode !== '2'"
                        :readonly = "this.viewMode === '2'"
                        hide-details
                        dark
                        solo-inverted
                        flat
                        :class="['small']"
                        :value="projectFilter"
                        @change="projectFilter = $event"
                        @click:clear="projectFilter = null"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <data-card-search-field v-model="search"></data-card-search-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
          </template>
          <hasy-data-table
            ref="dataTable"
            :headers="headers"
            :items="items"
            :loading="isLoading"
            :selected-item.sync="selectedItem"
            :pagination.sync="pagination"
            :search="search"
            enable-item-tooltips
            >
          </hasy-data-table>
        </data-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Api } from '@/api/apiAccess'
import { mapGetters } from 'vuex'
import Routes from '@/router/routes'
import mutationtypes from '@/store/modules/report/singleentries/mutation-types'
import moduleNames from '@/store/moduleNames'
import { storedSelectedItemMixin, navigationBackButtonStateMixin, storedPaginationMixin, storedTableSearchMixin, storedPropertyMixin, selectYearAdvancedMixin, pageTitleMixin } from '@/mixins/mixins'

const storeModule = moduleNames.REPORTSINGLEENTRIES

export default {
  props: {
    yearParam: {
      default: undefined
    },
    periodFromParam: {
      default: undefined
    },
    periodToParam: {
      default: undefined
    },
    facilityParam: {
      default: undefined
    },
    costCenterParam: {
      default: undefined
    },
    generalLedgerAccountParam: {
      default: undefined
    },
    projectParam: {
      default: undefined
    },
    mode: {
      default: '1'
    }
  },
  mixins: [
    storedSelectedItemMixin(storeModule, mutationtypes.UPDATE_SINGLEENTRYLISTSELECT_STATE, 'singleEntryListSelectedState', 'selectedItem'),
    navigationBackButtonStateMixin(storeModule, mutationtypes.UPDATE_SINGLEENTRYNAVIGATIONBACKBUTTON_STATE, 'singleEntryNavigationBackButtonState'),
    storedPaginationMixin(storeModule + '/pagination'),
    storedTableSearchMixin(storeModule, mutationtypes.UPDATE_SINGLEENTRYLISTTABLESEARCH_STATE, 'singleEntryListTableSearchState', 'dataTableSearch'),
    storedPropertyMixin('selectedYear', storeModule, mutationtypes.UPDATE_SINGLEENTRYLIST_SELECTED_YEAR, 'selectedYear', 'year'),
    storedPropertyMixin('selectedPeriodAt', storeModule, mutationtypes.UPDATE_SINGLEENTRYLIST_SELECTED_PERIODAT, 'selectedPeriodAt', 'period'),
    storedPropertyMixin('selectedPeriodTo', storeModule, mutationtypes.UPDATE_SINGLEENTRYLIST_SELECTED_PERIODTO, 'selectedPeriodTo', 'period'),
    storedPropertyMixin('selectedFacilityId', storeModule, mutationtypes.UPDATE_SINGLEENTRYLIST_SELECTED_FACILITY, 'selectedFacility', 'facility'),
    storedPropertyMixin('costCenterFilter', storeModule, mutationtypes.UPDATE_SINGLEENTRYLIST_COSTCENTER_FILTER, 'costCenterFilter', 'costcenter'),
    storedPropertyMixin('generalLedgerAccountFilter', storeModule, mutationtypes.UPDATE_SINGLEENTRYLIST_GENERALLEDGERACCOUNT_FILTER, 'generalLedgerAccountFilter', 'generalledgeraccount'),
    storedPropertyMixin('projectFilter', storeModule, mutationtypes.UPDATE_SINGLEENTRYLIST_PROJECT_FILTER, 'projectFilter', 'project'),
    storedPropertyMixin('viewMode', storeModule, mutationtypes.UPDATE_SINGLEENTRYLIST_VIEW_MODE, 'viewMode', 'viewmode'),
    selectYearAdvancedMixin,
    pageTitleMixin
  ],
  data () {
    return {
      navigationBackButtonState: { isVisible: false },
      isLoading: false,
      items: [],
      selected: {},
      loading: false,
      headers: [
        {
          text: this.$t('report.singleEntries.period'),
          align: 'right',
          contentAlign: 'right',
          value: 'bookingPeriod',
          dataType: 'number',
          width: '5%'
        },
        {
          text: this.$t('report.singleEntries.bookingDate'),
          align: 'center',
          contentAlign: 'center',
          value: 'bookingDate',
          dataType: 'date',
          width: '5%'
        },
        {
          text: this.$t('report.singleEntries.costCenter'),
          align: 'left',
          value: 'costCenter',
          dataType: 'string',
          contentClasses: 'no-wrap trim',
          width: '12%'
        },
        {
          text: this.$t('report.singleEntries.project'),
          align: 'left',
          value: 'project',
          dataType: 'string',
          contentClasses: 'no-wrap trim',
          width: '11%'
        },
        {
          text: this.$t('report.singleEntries.voucherDate'),
          align: 'left',
          contentAlign: 'center',
          value: 'voucherDate',
          dataType: 'date',
          width: '5%'
        },
        {
          text: this.$t('report.singleEntries.voucherNumber'),
          align: 'left',
          value: 'voucherNumber',
          dataType: 'string',
          width: '9%'
        },
        {
          text: this.$t('report.singleEntries.generalLedgerAccount'),
          align: 'left',
          value: 'generalLedgerAccount',
          dataType: 'string',
          contentClasses: 'no-wrap trim',
          width: '12%'
        },
        {
          text: this.$t('report.singleEntries.bookingText'),
          align: 'left',
          value: 'bookingText',
          dataType: 'string',
          contentClasses: 'no-wrap trim',
          width: '15%'
        },
        {
          text: this.$t('report.singleEntries.planRevenue'),
          align: 'right',
          value: 'planRevenue',
          dataType: 'currency',
          contentAlign: 'right',
          classes: 'wrap-header',
          contentFormat: (v) => this.$n(v, 'numberWith2DecimalGrouping'),
          width: '6%'
        },
        {
          text: this.$t('report.singleEntries.planIssue'),
          align: 'right',
          value: 'planIssue',
          dataType: 'currency',
          contentAlign: 'right',
          classes: 'wrap-header',
          contentFormat: (v) => this.$n(v, 'numberWith2DecimalGrouping'),
          width: '6%'
        },
        {
          text: this.$t('report.singleEntries.actualRevenue'),
          align: 'right',
          value: 'actualRevenue',
          dataType: 'currency',
          contentAlign: 'right',
          classes: 'wrap-header',
          contentFormat: (v) => this.$n(v, 'numberWith2DecimalGrouping'),
          width: '6%'
        },
        {
          text: this.$t('report.singleEntries.actualIssue'),
          align: 'right',
          value: 'actualIssue',
          dataType: 'currency',
          contentAlign: 'right',
          classes: 'wrap-header',
          contentFormat: (v) => this.$n(v, 'numberWith2DecimalGrouping'),
          width: '6%'
        },
        {
          text: this.$t('report.singleEntries.balance'),
          align: 'right',
          value: 'balance',
          dataType: 'currency',
          contentAlign: 'right',
          contentFormat: (v) => this.$n(v, 'numberWith2DecimalGrouping'),
          width: '6%'
        }
      ],
      bookingPeriods: [...Array.from(new Array(15), (x, i) => {
        if (i < 12) {
          let objDate = new Date()
          objDate.setDate(1)
          objDate.setMonth(i)
          return {
            text: objDate.toLocaleString(this.$i18n.locale, { month: 'long' }),
            value: i + 1
          }
        } else {
          return {
            text: this.$tc('report.singleEntries.annualAccounts', i - 12),
            value: i + 1
          }
        }
      })],
      facilityList: [],
      isLoadingFacilities: false,
      isInitialized: false,
      isLoadingPastYear: false
    }
  },
  computed: {
    ...mapGetters(['isUserAdministrator']),
    exportUrl () {
      let paramCreator = Api.ReportParamCreator
      let year = this.selectedYear
      let periodAt = this.selectedPeriodAt
      let periodTo = this.selectedPeriodTo
      let facility = this.viewMode === '1' ? this.selectedFacilityId : null
      let culture = this.$i18n.locale
      let costcenter = this.costCenterFilter
      let generalledgeraccount = this.generalLedgerAccountFilter
      let project = this.projectFilter
      let mode = this.viewMode
      let params = paramCreator.reportExportSingleEntries(facility, year, periodAt, periodTo, costcenter, generalledgeraccount, project, mode, culture)
      let relativeUrl = params.url
      let basePath = Api.BasePath

      if (relativeUrl == null || relativeUrl.length <= 0 || basePath == null || basePath.length <= 0) {
        return null
      }

      return basePath + relativeUrl
    },
    exportAcrossFacilitiesUrl () {
      let paramCreator = Api.ReportParamCreator
      let year = this.selectedYear
      let periodAt = this.selectedPeriodAt
      let periodTo = this.selectedPeriodTo
      let culture = this.$i18n.locale
      let costcenter = this.costCenterFilter
      let generalledgeraccount = this.generalLedgerAccountFilter
      let project = this.projectFilter
      let mode = this.viewMode
      let params = paramCreator.reportExportSingleEntriesAcrossFacilities(null, year, periodAt, periodTo, costcenter, generalledgeraccount, project, mode, culture)
      let relativeUrl = params.url
      let basePath = Api.BasePath

      if (relativeUrl == null || relativeUrl.length <= 0 || basePath == null || basePath.length <= 0) {
        return null
      }

      return basePath + relativeUrl
    },
    exportProjectAdminsUrl () {
      let paramCreator = Api.ReportParamCreator
      let year = this.selectedYear
      let periodAt = this.selectedPeriodAt
      let periodTo = this.selectedPeriodTo
      let culture = this.$i18n.locale
      let costcenter = this.costCenterFilter
      let generalledgeraccount = this.generalLedgerAccountFilter
      let project = this.projectFilter
      let mode = this.viewMode
      let params = paramCreator.reportExportSingleEntriesProjectAdmins(null, year, periodAt, periodTo, costcenter, generalledgeraccount, project, mode, culture)
      let relativeUrl = params.url
      let basePath = Api.BasePath

      if (relativeUrl == null || relativeUrl.length <= 0 || basePath == null || basePath.length <= 0) {
        return null
      }

      return basePath + relativeUrl
    },
    balancesOfCostCentersUrl () {
      return { name: Routes.BALANCES_OF_COST_CENTERS, query: { y: this.selectedYear, pf: this.selectedPeriodAt, pt: this.selectedPeriodTo, f: this.selectedFacilityId } }
    },
    balancesOfProjectsUrl () {
      return { name: Routes.BALANCES_OF_PROJECTS, query: { y: this.selectedYear, pf: this.selectedPeriodAt, pt: this.selectedPeriodTo, f: this.selectedFacilityId } }
    },
    resetSingleEntriesUrl () {
      return { name: Routes.SINGLE_ENTRIES, query: { mo: '1' } }
    }
  },
  watch: {
    selectedYear (v) {
      this.loadData(1)
    },
    selectedPeriodAt (v) {
      this.loadData(2)
    },
    selectedPeriodTo (v) {
      this.loadData(3)
    },
    selectedFacilityId (v) {
      this.loadData(4)
    },
    costCenterFilter (v) {
      this.loadData(5)
    },
    generalLedgerAccountFilter (v) {
      this.loadData(6)
    },
    projectFilter (v) {
      this.loadData(7)
    },
    $route (to, from) {
      // react to route changes...
      if (to.path === from.path && from.query.mo && from.query.mo === '2' && ((to.query.mo && to.query.mo === '1') || !to.query.mo)) {
        this.selectedYear = new Date().getFullYear()
        this.selectedPeriodAt = 1
        this.selectedPeriodTo = new Date().getMonth() + 1
        this.selectedFacilityId = undefined
        this.costCenterFilter = undefined
        this.generalLedgerAccountFilter = undefined
        this.projectFilter = undefined
        this.viewMode = '1'

        this.loadFacilities()
          .then(() => {
            if (this.selectedFacilityId == null) {
              let facilities = this.facilityList || []
              let firstFacility = facilities[0]
              if (firstFacility != null) {
                this.selectedFacilityId = firstFacility.id
              }
            }
            this.$nextTick(() => {
              this.isInitialized = true
              this.loadData()
            })
          })
      }
    }
  },
  methods: {
    loadFacilities () {
      this.isLoadingFacilities = true
      let facilityApi = Api.Facility

      return facilityApi.facilityGetAllAuthorizedActive(4)
        .then(r => {
          this.facilityList = r.data
          return Promise.resolve()
        },
        err => {
          return Promise.reject(err)
        })
        .finally(() => {
          this.isLoadingFacilities = false
        })
    },
    loadData (callType) {
      if (!this.isInitialized) {
        return Promise.resolve()
      }
      if (this.viewMode !== '2' && this.selectedFacilityId == null) {
        this.items = []
        return Promise.resolve()
      }

      if (this.isLoadingPastYear) {
        return Promise.resolve()
      }

      let year = this.selectedYear

      if (callType === 1) {
        if (this.selectedYear < new Date().getFullYear()) {
          this.isLoadingPastYear = true
          this.selectedPeriodAt = this.bookingPeriods[0].value
          this.selectedPeriodTo = this.bookingPeriods[this.bookingPeriods.length - 1].value
        }
      }

      let periodAt = this.selectedPeriodAt
      let periodTo = this.selectedPeriodTo
      let facility = this.viewMode === '1' ? this.selectedFacilityId : null
      let ccf = this.costCenterFilter
      let glaf = this.generalLedgerAccountFilter
      let pf = this.projectFilter
      let mo = this.viewMode

      this.isLoading = true
      let ep = Api.Report
      return ep.reportGetSingleEntries(facility, year, periodAt, periodTo, ccf, glaf, pf, mo)
        .then(r => {
          this.items = r.data
          return Promise.resolve()
        },
        err => {
          return Promise.reject(err)
        })
        .finally(() => {
          this.isLoading = false
          this.isLoadingPastYear = false
          this.restoreSelectedItem()
        })
    },
    init () {
      if (this.selectedYear == null) {
        this.selectedYear = new Date().getFullYear()
      }
      if (this.selectedPeriodAt == null) {
        this.selectedPeriodAt = 1
      }
      if (this.selectedPeriodTo == null) {
        this.selectedPeriodTo = new Date().getMonth() + 1
      }

      if (this.yearParam != null) {
        this.selectedYear = this.yearParam
      }

      if (this.periodFromParam != null) {
        this.selectedPeriodAt = this.periodFromParam
      }

      if (this.periodToParam != null) {
        this.selectedPeriodTo = this.periodToParam
      }

      if (this.facilityParam != null) {
        this.selectedFacilityId = this.facilityParam
      }

      if (this.costCenterParam != null) {
        this.costCenterFilter = this.costCenterParam
      }

      if (this.generalLedgerAccountParam != null) {
        this.generalLedgerAccountFilter = this.generalLedgerAccountParam
      }

      if (this.projectParam != null) {
        this.projectFilter = this.projectParam
      }

      if (this.mode != null) {
        this.viewMode = this.mode
      }

      if (this.viewMode === '2') {
        this.isInitialized = true
        this.loadData()
      } else {
        this.loadFacilities()
          .then(() => {
            if (this.selectedFacilityId == null) {
              let facilities = this.facilityList || []
              let firstFacility = facilities[0]
              if (firstFacility != null) {
                this.selectedFacilityId = firstFacility.id
              }
            }
            this.$nextTick(() => {
              this.isInitialized = true
              this.loadData(0)
            })
          })
      }
    }
  },
  created () {
    this.init()
  }
}

</script>

<style lang="scss">
.repCostCenterContainer {

  .data-table {

    tbody {

      > tr {

        &:not(:last-child) {
          border-bottom: none;
        }

        &.sumTotal {
          border-bottom: 1px solid rgba(255,0,0,.4);
        }

        &.sumAllCostCenters {
          border-bottom: 1px dotted rgba(255,0,0,.4);
        }

        &.sumTotal,
        &.sumAllCostCenters {

          > td {
            font-weight: 500;
          }
        }

        &.sumAllGeneralLedgerAccounts {

          > td {
            font-style: italic;
          }
        }
      }
    }
  }

  .v-table>tbody>tr>td {
    padding: 0 2px !important;
  }

  .v-table>thead>tr>th {
    padding: 0 2px !important;
  }
}
</style>
